import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './auth/login/login.component';
import { SignupComponent } from './auth/signup/signup.component';
import { AuthGuard } from './services/guards/auth.guard';
import { CategoryComponent } from './user/category/category.component';
import { CategoryBrowserComponent } from './user/category-browser/category-browser.component';
import { MyFavoritesComponent } from './user/my-favorites/my-favorites.component';
import { CashbackComponent } from './user/cashback/cashback.component';
import { SignoutComponent } from './signout/signoutcomponent';
import { AdminAppliListComponent } from './admin/appli/appli-list/appli-list.component';
import { AdminAppliDetailComponent } from './admin/appli/appli-detail/appli-detail.component';
import { CategoryDetailComponent } from './user/category-detail/category-detail.component';
import { SelectFavoriteAppComponent } from './user/select-favorite-app/select-favorite-app.component';
import { CashbackRequestComponent } from './user/cashback-request/cashback-request.component';

const routes: Routes = [
 
  { path: 'home', component: HomeComponent, canLoad: [ AuthGuard ]},
  { path: 'login', component: LoginComponent},
  { path: 'signup', component: SignupComponent},
  { path: 'category/:name/:subcategory', component: CategoryComponent}, // Category with subcategory
  { path: 'category/:name', component: CategoryComponent}, // Category only
  { path: 'category', component: CategoryComponent},
  { path: 'category-browser', component: CategoryBrowserComponent},
  { path: 'category-detail/:categoryId', component: CategoryDetailComponent, canLoad: [ AuthGuard ]},
  { path: 'select-app/:subCategoryId', component: SelectFavoriteAppComponent, canLoad: [ AuthGuard ]},
  { path: 'my-favorites', component: MyFavoritesComponent, canLoad: [ AuthGuard ]},
  { path: 'cashback-request', component: CashbackRequestComponent, canLoad: [ AuthGuard ]},
  { path: 'appli-list', component: AdminAppliListComponent},
  { path: 'appli-detail/:id', component: AdminAppliDetailComponent},
  { path: 'appli-detail', component: AdminAppliDetailComponent},
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'signout', component: SignoutComponent, canLoad: [ AuthGuard ]},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0,64]
  })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
